// Native device contact actions — used as a fallback when in-app messaging
// (Twilio for call/SMS, Gmail for email) isn't connected for the business.

/** Keep digits and a leading +, which is all tel:/sms: need. */
function sanitizePhone(phone: string): string {
  return String(phone || '').replace(/[^\d+]/g, '');
}

/** Open the device's native phone dialer/call sheet. */
export function openNativeCall(phone: string | null | undefined): void {
  const p = sanitizePhone(phone || '');
  if (!p) return;
  window.location.href = `tel:${p}`;
}

/** Open the device's native SMS composer. */
export function openNativeSms(phone: string | null | undefined): void {
  const p = sanitizePhone(phone || '');
  if (!p) return;
  window.location.href = `sms:${p}`;
}

/** Open the device's native email composer. */
export function openNativeEmail(email: string | null | undefined, subject?: string): void {
  const e = (email || '').trim();
  if (!e) return;
  const qs = subject ? `?subject=${encodeURIComponent(subject)}` : '';
  window.location.href = `mailto:${e}${qs}`;
}
